<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Доставка пива</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <p style="margin-top:2%;">Любите проводить время в компании друзей за бокалом холодного пива, но не хотите тратить время на поиски хорошего бара и пивоварни? Или же вы предпочитаете расслабиться в пятницу вечером перед телевизором? Тогда мы предлагаем Вам доставку пива на дом.</p>
            <p>Купить пиво можно через наш сайт. Мы обрадуем Вас большим выбором.  Закажите любое пиво на Ваш вкус: светлое и темное, разливное и бутылочное, крафтовое и многое другое.</p>
            <p>Мы заботимся о том, чтобы на нашем сайте были только лучшие пивоварни Вашего города. Мы считаем, что качество и вкус — это главное. Вы тоже? Тогда Вам у нас понравится.</p>
            <p>Мы доставляем пиво ночью и днем. Круглосуточно! Закажи пиво с доставкой на дом, а мы доставим его холодным в любое время суток!</p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'beer'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/beer.vue